import { jQueryLikeParamSerializer } from '../utils.js';

const ENDPOINT = 'POSTalbumuploadV2';
function postAlbumUpload(gateway, params) {
    return gateway.post(postAlbumUpload.endpoint, {}, jQueryLikeParamSerializer(params), null, null, 'encrypted');
}
postAlbumUpload.endpoint = ENDPOINT;

export { postAlbumUpload as default };
//# sourceMappingURL=postAlbumUpload.js.map
